import type { RootState } from 'store';

export const selectHasAuthCredentials = (state: RootState): boolean =>
  Boolean(
    state.persistAuth.userInfo?.clid && state.persistAuth.userInfo?.token
  );

/** True when the user profile and API credentials are both available. */
export const selectIsAuthenticated = (state: RootState): boolean =>
  Boolean(selectHasAuthCredentials(state) && state.user.user);

/** Use for authenticated RTK Query calls on private routes (user is guaranteed by routing). */
export const selectCanFetchAuthenticatedApi = (state: RootState): boolean =>
  Boolean(state.user.user && selectHasAuthCredentials(state));
